import React, {useContext} from 'react'
import NavBar from './NavBar'
import Footer from './Footer'
import {NotificacionesContext, NotificacionesProvider} from "../context/notificaciones";
import useWebSocket from "react-use-websocket";


const getURLWSBase = () => {
  return process.env.REACT_APP_API.replace('http', 'ws') + "/ws";
}

const IndexNotificaciones = () => {
  const {setNotificaciones} = useContext(NotificacionesContext);
  const token = localStorage.getItem('token');


  const {readyState} = useWebSocket(getURLWSBase(), {
    queryParams: {token: token,},
    shouldReconnect: () => true,
    reconnectInterval: 5000,
    onMessage: (event) => {
      let objectData = JSON.parse(event.data);
      setNotificaciones(
        objectData.message.contador_notificaciones,
      )
    }
  });
  return <></>
}


const MainLayout = ({children}) => {
  return (
    <>
      <NotificacionesProvider>
        <IndexNotificaciones/>
        <NavBar/>
        <div className='container'>
          {children}
        </div>
        <Footer/>
      </NotificacionesProvider>
    </>
  )
}

export default MainLayout